var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "fclc-sm": !_vm.windowIsLarge } },
    [
      _vm._t("header"),
      _vm._t("abovechannels"),
      _c(
        "KGrid",
        { staticClass: "top-panel" },
        [
          _vm.channels.length > 0
            ? [
                _c(
                  "KGridItem",
                  { attrs: { layout12: { span: 4 } } },
                  [
                    _c("KSelect", {
                      staticClass: "filter-lang",
                      attrs: {
                        options: _vm.languageFilterOptions,
                        label: _vm.coreString("languageLabel"),
                        inline: true,
                      },
                      model: {
                        value: _vm.languageFilter,
                        callback: function ($$v) {
                          _vm.languageFilter = $$v
                        },
                        expression: "languageFilter",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "KGridItem",
                  {
                    staticClass: "filter-title",
                    attrs: { layout12: { span: 5 } },
                  },
                  [
                    _c("FilterTextbox", {
                      attrs: {
                        placeholder: _vm.$tr("titleFilterPlaceholder"),
                        throttleInput: 500,
                      },
                      model: {
                        value: _vm.titleFilter,
                        callback: function ($$v) {
                          _vm.titleFilter = $$v
                        },
                        expression: "titleFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c("KGridItem", { attrs: { layout12: { span: 3 } } }, [
            _c(
              "p",
              { staticClass: "count-msg", attrs: { "data-test": "available" } },
              [_vm._v("\n        " + _vm._s(_vm.channelsCountMsg) + "\n      ")]
            ),
          ]),
        ],
        2
      ),
      _vm.selectAllCheckbox
        ? [
            _vm.filteredItems.length > 0
              ? _c("KCheckbox", {
                  staticClass: "select-all-checkbox",
                  attrs: {
                    label: _vm.$tr("selectAll"),
                    checked: _vm.selectAllIsChecked,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleChangeSelectAll({ isSelected: $event })
                    },
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._t("default", null, null, {
        filteredItems: _vm.filteredItems,
        showItem: _vm.showItem,
        itemIsSelected: _vm.itemIsSelected,
        handleChange: _vm.handleChange,
      }),
      _vm.filteredItems.length === 0
        ? _c("div", { staticClass: "no-match" }, [
            _vm._v("\n    " + _vm._s(_vm.noMatchMsg) + "\n  "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }